import { type Components } from '@mui/material';

import { type horizonTheme } from './horizon-theme';

export const muiCheckbox: Components<typeof horizonTheme>['MuiCheckbox'] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      transform: 'scale(0.75)',
      color: theme.palette.gray500.main,
      backgroundColor: 'transparent',

      '&:hover': {
        backgroundColor: 'transparent',
        '&.Mui-checked': {
          color: theme.palette.white.main,
        },
      },

      '&.Mui-checked': {
        color: theme.palette.blue.main,
        '& .MuiSvgIcon-root': {
          color: theme.palette.blue.main,
        },
      },

      '&.Mui-disabled': {
        color: theme.palette.gray300.main,
        '&.Mui-checked': {
          color: theme.palette.gray300.main,
        },
      },

      '& .MuiSvgIcon-root': {
        color: theme.palette.gray500.main,
      },
    }),
  },
};
